import { render, staticRenderFns } from "./modifyPass.vue?vue&type=template&id=edd5f988&scoped=true&"
import script from "./modifyPass.vue?vue&type=script&lang=js&"
export * from "./modifyPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd5f988",
  null
  
)

export default component.exports